import { PluginFunction } from 'vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export interface ConfirmDialogOptions {
  property: string
}

export const ConfirmDialogPlugin: PluginFunction<ConfirmDialogOptions> = (Vue, options) => {
  const property = options && options.property || '$confirm'

  function createDialogComponent(options: any) {
    return new Promise<boolean>(resolve => {
      const comp = new ConfirmDialog({
        destroyed: () => {
          document.body.removeChild(comp.$el)
          resolve((comp as any).value) // for some reason, VSC fails to recognize "value" as a property of ConfirmDialog...
        }
      })
      Object.assign(comp, Vue.prototype[property].options || {}, options)
      document.body.appendChild(comp.$mount().$el)
    })
  }

  function show(message: string, options: any = {}) {
    options.message = message
    return createDialogComponent(options)
  }

  Vue.prototype[property] = show
  Vue.prototype[property].options = options || {}
}

declare module 'vue/types/vue' {
  interface Vue {
    $confirm: (message: string, options?: any) => Promise<boolean>
  }
}
